import axios from 'axios'
const uri = 'subir-xframe/php/'
const get = (url) => {
	return axios.get(uri + url)
}

export default {
	getBuzones () {
		return get('listado-buzones.php')
	},

	getPendientes () {
		return get('check.php')
	}
}



// WEBPACK FOOTER //
// ./src/modulos/subir-xframe/vue/api.js